import React from "react";
import useLoadGame from "hooks/useLoadGame"
import { GameButton } from "@fedsim/components"
import { trackEv, Categories, Actions } from 'analytics'

import { UploadIcon } from "icons";

export function LoadSave({
  size = "small",
  variant = "contained",
  color = "success",
}) {
  const onComplete = () => {
    trackEv(Categories.Setup, Actions.Load)

    alert("Loaded")
  }
  const { getRootProps, getInputProps } = useLoadGame({ onComplete })
  const props = {
    size,
    variant,
    color,
  }

  return (
    <React.Fragment>
      <input {...getInputProps()} />
      <GameButton startIcon={<UploadIcon />} {...getRootProps()} {...props}>Load Save</GameButton>
    </React.Fragment>
  )
}

export default LoadSave
